var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlmonds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#E58037;}\n\t.st2{fill:#F49C58;}\n\t.st3{fill:#CF6215;}\n\t.st4{fill:#BE5623;}\n\t.st5{fill:#FFE9C0;}\n\t.st6{fill:#FFF7E7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.69,57.87c-4.03,1-16.43,34.05-10.48,58.06c5.95,24.01,19.08,32.1,32.02,28.89 c12.94-3.21,20.78-16.49,14.83-40.5C103.11,80.32,77.15,56.77,72.69,57.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.85,80.14c1.34,2.62,2.4,5.41,3.38,8.18c1.3,3.66,2.43,7.39,3.4,11.16c1.94,7.53,3.41,15.25,3.91,23.02 c0.08,1.17,0.14,2.35,0.14,3.53c-1.11-2.91-1.96-5.94-2.81-8.94c-1.07-3.78-2.05-7.59-2.97-11.41 c-1.81-7.46-3.47-14.98-4.64-22.58C77.12,82.12,76.98,81.13,76.85,80.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.08,82.04c0.25,5.78,0.41,11.58,1,17.33c0.38,3.68,0.87,7.32,1.55,10.96c0.56,3.04,1.57,5.91,2.56,8.82 c-3.57-5.36-5.23-11.73-5.83-18.09C67.84,94.78,67.7,88.24,69.08,82.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.69,57.87c-1.1,0.27-2.82,2.94-4.63,7.15c9.53,7.67,24.43,24.88,28.75,42.34 c4.97,20.08,0.3,32.65-8.92,38.11c2.1,0.1,4.22-0.11,6.34-0.64c12.94-3.21,20.78-16.49,14.83-40.5 C103.11,80.32,77.15,56.77,72.69,57.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.43,71.04c2.36,21.53,6.79,41.78,13.5,62.29C75.25,116.22,73.5,91.02,73.43,71.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.52,108.98c3.41,13.5,11.34,24.43,21.11,33.63C72.34,137.11,65.95,122.15,64.52,108.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.1,61.11c7.2,13.47,13.8,28.36,15.14,43.71C83.03,90.74,78.77,75.02,73.1,61.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.52,59.62c14.78,11.71,26.23,30.74,26.12,49.94C95.12,91.43,88.24,73.21,74.52,59.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.99,97.7c5.04,13.28,7.43,29.97-2.54,41.56C105.37,125.68,106.19,111.71,102.99,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.52,142.32c-0.5-11.01-3.66-22.07-5.38-32.61C93.02,119.75,94.38,131.58,93.52,142.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.35,72.71c-3.88-1.47-32.87,18.68-41.62,41.82c-8.75,23.14-2.54,37.26,9.92,41.97 c12.47,4.72,26.47-1.76,35.22-24.89C155.62,108.47,147.65,74.34,143.35,72.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M117.87,119.53c-3.24,8.57-7.85,14.77-10.3,13.85c-2.44-0.92-1.8-8.62,1.45-17.2s7.85-14.77,10.3-13.85 C121.76,103.26,121.11,110.95,117.87,119.53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmonds);
export default __webpack_public_path__ + "static/media/Almonds.dbbcfac3567c7cc3d48eb9ec57cdc12a.svg";
export { ForwardRef as ReactComponent };